import { EThemesEnum } from '@enum';
import { THEME_STORAGE_KEY } from '@consts';

export const localStorageSetter = (key: string, value: any) => {
  let stringedValue = value;

  if (typeof value !== 'string') stringedValue = JSON.stringify(value);

  localStorage.setItem(key, stringedValue);
};

export const localStorageGetter = (key: string) => localStorage.getItem(key);

export const ThemeStorageGetter = () => localStorageGetter(THEME_STORAGE_KEY);
export const ThemeStorageSetter = (value: any) =>
  localStorageSetter(THEME_STORAGE_KEY, value);

export const themeFromLSParser = () => {
  const result = ThemeStorageGetter();
  if (
    result &&
    Object.values(EThemesEnum)
      .map((one) => one.toString())
      .includes(result)
  ) {
    return result as EThemesEnum;
  }

  return EThemesEnum.dark;
};
